import i18n from "@/i18n";
import {
  IContractProductProvider,
  IProvisioningProvider
} from "@/models/providers/contractProduct";
import { IMenuRoute } from "@/models/routes";

export function cProdSubscriptionsTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_.active"),
      to: { name: "adminClientActiveSubscriptions" }
    },
    {
      label: i18n.t("_.cancelled"),
      to: { name: "adminClientCancelledSubscriptions" }
    },
    {
      label: i18n.t("_.all"),
      to: { name: "adminClientAllSubscriptions" }
    }
  ];
}

export function cProdOTPsTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_.active"),
      to: { name: "adminClientActiveOTPs" }
    },
    {
      label: i18n.t("_.cancelled"),
      to: { name: "adminClientCancelledOTPs" }
    },
    {
      label: i18n.t("_.all"),
      to: { name: "adminClientAllOTPs" }
    }
  ];
}

export function cProdTabigation({
  $cProdData,
  $cProdProvData
}: {
  $cProdData: IContractProductProvider;
  $cProdProvData: IProvisioningProvider;
}) {
  return [
    {
      label: i18n.t("_.overview"),
      to: {
        name: `adminClientCProdOverview`
      }
    },
    {
      label: i18n.t("_.invoices"),
      to: {
        name: `adminClientCProdInvoices`
      }
    },
    {
      label: i18n.t("_.credit_notes"),
      to: {
        name: `adminClientCProdCreditNotes`
      }
    },
    {
      label: i18n.t("_.manage"),
      to: {
        name: `adminClientCProdProvisioning`
      },
      if: () => {
        return $cProdProvData.canManageProvisioning;
      }
    },
    {
      label: i18n.t("_.settings"),
      to: {
        name: `adminClientCProdSettings`
      },
      if: () => {
        return $cProdData.canModifySettings;
      }
    },
    {
      label: i18n.t("_.delegates"),
      to: {
        name: `adminClientCProdDelegates`
      }
    },
    {
      label: i18n.t("_.activity_log"),
      to: {
        name: `adminClientCProdActivities`
      }
    }
  ];
}
